export default __webpack_public_path__ + "static/media/default_profile.0c22186a.jpg";